import { render, staticRenderFns } from "./PrimaryNavbar.vue?vue&type=template&id=4ea5a91c&scoped=true&"
import script from "./PrimaryNavbar.vue?vue&type=script&lang=js&"
export * from "./PrimaryNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea5a91c",
  null
  
)

export default component.exports